import type { RoleName } from "@storytell/types";
import { StButton } from "@storytell/ui/buttons";
import { TbCheck, TbCopy, TbTrash } from "solid-icons/tb";
import { type Component, Show } from "solid-js";
import { useWire } from "~/wire";
import { mapRoleToUI } from "./roleUtils";

interface EmailInviteCardProps {
  email: string;
  role: RoleName;
  inviteId: string;
  inviteLink: string;
  isCopied: boolean;
  onCopy: (link: string, id: string) => void;
  onDelete: (inviteId: string, email: string, role: RoleName) => void;
}

export const EmailInviteCard: Component<EmailInviteCardProps> = (props) => {
  const wire = useWire();
  return (
    <div class="flex items-center justify-between p-3 bg-panel border border-primary-border rounded-lg w-full min-w-0">
      <div class="flex items-center gap-4 min-w-0 flex-1">
        <span class="text-sm font-medium truncate">{props.email}</span>
        <span class="text-xs text-muted-text">•</span>
        <span class="text-sm text-muted-text">{mapRoleToUI(props.role)}</span>
      </div>
      <div class="flex items-center gap-2">
        <StButton onClick={() => props.onCopy(props.inviteLink, props.inviteId)} class="shrink-0">
          <Show
            when={props.isCopied}
            fallback={
              <>
                <TbCopy class="w-4 h-4 mr-1" /> Copy Invite
              </>
            }
          >
            <>
              <TbCheck class="w-4 h-4 mr-1" /> Copied!
            </>
          </Show>
        </StButton>
        <Show when={wire.grants.canDelete("cp.invitations_users")}>
          <StButton
            onClick={() => props.onDelete(props.inviteId, props.email, props.role)}
            class="shrink-0 text-red-500 hover:text-red-600"
          >
            <TbTrash class="w-4 h-4" />
          </StButton>
        </Show>
      </div>
    </div>
  );
};
